import i18nReducers from './i18n';
import commonReducers from './common';
import siteReducers from './site';
import loginReducers from './login';
import menuReducers from './menu';
import accountReducers from './account';
import deviceReducers from './device';
import modelReducers from './model';
import visualReducers from './visual';
import settingsReducers from './settings';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { USER_LOGOUT } from '../actions/login/index';

const appReducer = combineReducers({
  i18nReducers,
  commonReducers,
  siteReducers,
  loginReducers,
  menuReducers,
  accountReducers,
  deviceReducers,
  modelReducers,
  visualReducers,
  settingsReducers,
  form: formReducer
})

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
